export const TESTIMONIAL_INPUT_NAME = {
  EXPERIENCE: 'experience',
  PUPPY_NAME: 'puppy_name',
  INSTAGRAM: 'instagram',
  BIRTH_DATE: 'birth_date'
};
